module.exports = __webpack_public_path__ + "static/media/img_pro.e49f6128.jpg";